const LoadingScreen = () => {
  return (
    <div className="flex w-full h-screen justify-center items-center">
      <h1 className="text-4xl font-bold">Loading...</h1>
    </div>
  );
};

export default LoadingScreen;
